import { useEffect, useRef, useState } from 'react';
import EditComponent from './MembershipRechargePlansEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { Button, Select, Space, Switch } from 'antd';
import dayjs from 'dayjs';
import MembershipRechargePlansApplicablesMerchants from './MembershipRechargePlansApplicablesMerchants';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'membershipRechargePlans';
    const [membershipRechargePlansId, setMembershipRechargePlansId] = useState<any>();
    const [modalVisibleMembershipRechargePlansApplicablesMerchants,
        setModalVisibleMembershipRechargePlansApplicablesMerchants] = useState<any>();
    const [membershipTypeData, setMembershipTypeData] = useState<any>();
    const [fethcData, setFethcData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>({
        showPageData: {
            membershipTypeId: 'allMembershipType'
        }
    });

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFethcData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'membershipType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipTypeData([{ id: 'allMembershipType', typeName: '所有' }, ...res.data]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '方案',
            dataIndex: 'planName',
        },
        {
            title: '会员类型',
            dataIndex: 'membershipType',
            render: (text: any) => text?.typeName
        },
        {
            title: '充值',
            dataIndex: 'depositBalance'
        },
        {
            title: '赠送',
            dataIndex: 'grantGifts'
        },
        {
            title: '积分',
            dataIndex: 'membershipPointsPlans',
            render: (val: any) => val?.planName
        },
        {
            title: '使用规则',
            dataIndex: 'isPermanentUse',
            render: (val: boolean, record: any) => {
                return (
                    val === true ?
                        '永久使用' :
                        `${dayjs(record?.startDate).format('YYYY-MM-DD')} 至 ` +
                        `${dayjs(record?.endDate).format('YYYY-MM-DD')}；` +
                        `${record?.totalCopies - record?.usedCopies}/${record?.totalCopies}`
                )
            }
        },
        {
            title: '适合商户',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setMembershipRechargePlansId({
                                membershipRechargePlansId: val
                            })
                            setModalVisibleMembershipRechargePlansApplicablesMerchants(true);
                        }}>{'适合商户'}</Button>
                    </Space>
                </>
            )
        },
        {
            title: '排序',
            dataIndex: 'sorting',
            sorter: true
        },
        {
            title: '显示',
            dataIndex: 'isShow',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '会员充值方案',
        apiId,
        columns,
        serviceId: 'business',
        editOptions: {
            Editor: EditComponent
        },
    };

    return (
        <><Space>
            <Select
                showSearch
                placeholder="会员类型"
                optionFilterProp="children"
                defaultValue={'allMembershipType'}
                onChange={(e) => {
                    const cs = {
                        showPageData: {
                            ...sendPageData.showPageData,
                            membershipTypeId: e
                        }
                    }
                    setSendPageData(cs);
                    fethcData({
                        apiId,
                        sendPageData: cs
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(membershipTypeData, { itemName: 'typeName' })}
            </Select>
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalVisibleMembershipRechargePlansApplicablesMerchants ?
                (<MembershipRechargePlansApplicablesMerchants
                    closeModal={() => setModalVisibleMembershipRechargePlansApplicablesMerchants(false)}
                    data={membershipRechargePlansId} />)
                : null}
        </>
    )
}

export default WebComponent;
